
























































import Vue from 'vue';
import Component from 'vue-class-component';
import TicketForm from '@/components/tickets/tickets-form/TicketForm.vue';
import LinkManagementGeneralInformation from '@/modules/tickets/incidents/link-management/components/LinkManagementGeneralInformation.vue';
import { LinkManagementData } from '@/modules/tickets/incidents/link-management/domain/link-management-data';
import { Typing } from '@/modules/tickets/shared/domain/typing';
import IncidentsDrawer from '@/modules/tickets/incidents/shared/components/IncidentDrawer.vue';
import { layout } from '@/modules/shared/shared/store/namespaces';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import LinkManagementTicketConfirmation from '@/modules/tickets/incidents/link-management/components/LinkManagementTicketConfirmation.vue';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import { linkManagement } from '@/modules/tickets/shared/store/namespaces';
import { LinkManagementActions } from '@/modules/tickets/incidents/link-management/store/link-management.actions';
import { LinkManagementGetters } from '@/modules/tickets/incidents/link-management/store/link-management.getters';
import { Incident } from '@/modules/tickets/incidents/shared/domain/incident';

@Component({
    name: 'link-management',
    components: {
        LinkManagementTicketConfirmation,
        IncidentsDrawer,
        LinkManagementGeneralInformation,
        TicketForm,
    },
})
export default class LinkManagement extends Vue {
    private currentStep: number = 1;
    private isValid: boolean = true;
    private highestStepReached: number = 1;
    private isMounted = false;

    async sendIncidentTicket() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);
        const failed = await this.createTicket(this.formValues.generalInformation);
        if (failed) {
            failed.showError();
        } else {
            this.$router.push({
                name: 'tickets',
            });
        }
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    nextStep() {
        if (this.currentStep < 2) {
            this.currentStep++;
            this.highestStepReached = this.currentStep;
        }
    }

    previousStep() {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    async mounted() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);
        this.changeTitle({ route: ['Tickets'], title: 'Incidente de Gestión de Enlaces' });
        const failed = await this.fetchView();

        if (failed) {
            failed.showError();
        }
        this.isMounted = true;

        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (layout: LayoutTitle) => void;

    @linkManagement.Action(LinkManagementActions.FETCH_VIEW)
    fetchView!: () => Promise<RequestResponse>;

    @linkManagement.Getter(LinkManagementGetters.GET_FORM_VALUES)
    formValues!: {
        generalInformation: LinkManagementData;
        typings: Typing[];
    };

    @linkManagement.Action(LinkManagementActions.CREATE_TICKET)
    createTicket!: (data: LinkManagementData) => Promise<RequestResponse>;

    @linkManagement.Getter(LinkManagementGetters.GET_OPEN_INCIDENTS)
    incidents!: Incident[];
}
